// The six cameras the Sales-env video wall is seeded with (ENG-32238). The
// wall in Sales is a fixed, non-editable grid, so this list is the whole
// configuration — there is no picker and no redux `cells` state behind it.
export interface SalesVideoWallCameraIProps {
  deviceId: string
  name: string
}

// Device UUIDs are the Austin Office ("HW Austin") entries from
// `features/canned-video/utils/data.ts` (salesDeviceNameDeviceIdMap). They are
// duplicated here rather than imported because cross-feature imports are not
// allowed, and these are static seed data, not live state. Each UUID has a
// canned mp4 mapped in that same file, which is what useCameraFeed serves when
// FeatureFlag.cannedVideo is on.
export const SALES_VIDEO_WALL_CAMERAS: SalesVideoWallCameraIProps[] = [
  { deviceId: '365f3d41-6d77-4b67-a737-ba71c76efb61', name: 'Breakroom' },
  { deviceId: '9d12c92c-6a0b-4184-bb23-a8e12bba0ebc', name: 'Bullpen 360' },
  { deviceId: '22937e6d-b795-4134-b214-2f32eba455ef', name: 'Dockweiler Bch' },
  { deviceId: '7df8768f-749b-4853-91b3-beb55f801bb6', name: 'EOC Conference' },
  {
    deviceId: '1b531ab6-e9e7-4b7a-9586-a5a47dad73b6',
    name: 'Front Door Fixed',
  },
  { deviceId: '3174fb36-a3ac-482f-9ad4-c1dc462cc5eb', name: 'Front Hallway' },
]
